module.exports = __webpack_public_path__ + "images/home/masters/luoyi-1b2fb62a4e7c43d4d8fe6107ea909d43.jpg";